import React from 'react';
import PropTypes from 'prop-types';

import { Tooltip, Icon } from '@ontruck/orc';

const StopCommentsCell = ({ hasComments, handleRenderComments }) => {
  return (
    hasComments && (
      <Tooltip
        position="left"
        skin="light"
        component={hasComments && <div>{handleRenderComments()}</div>}
      >
        <Icon glyph="comments" size="1.6rem" color="grey500" />
      </Tooltip>
    )
  );
};

StopCommentsCell.propTypes = {
  hasComments: PropTypes.bool.isRequired,
};

export default StopCommentsCell;
